import {Wrapper, Button} from "../../components";
import HeroImg from "../../assets/hero2.png";

function Hero(){
    return(
       <div className="bg-[#18191D] relative overflow-hidden">
           {/* Dekoratif arka plan elementleri */}
           <div className="absolute top-20 left-10 w-64 h-64 bg-primary/5 rounded-full blur-3xl"></div>
           <div className="absolute bottom-20 right-10 w-80 h-80 bg-primary/10 rounded-full blur-3xl"></div>
           
           <Wrapper>
               <div className="grid grid-cols-12 items-center pt-28 pb-36 relative z-10">
                   <div className="md:col-start-1 md:col-end-7 col-start-1 col-end-13 animate-fadeIn">
                       <div className="inline-flex items-center bg-dark-backgroundOnDark/80 backdrop-blur-sm rounded-full py-1.5 px-4 mb-6 border border-primary/30">
                           <span className="w-2 h-2 rounded-full bg-primary animate-pulse mr-2"></span>
                           <span className="text-primary text-sm font-medium">Güvenilir Kripto Para Borsası</span>
                       </div>
                       
                       <h3 className="font-dmsans font-bold text-4xl md:text-6xl text-surface-main leading-tight">
                       <span className="mb-2">Güvenilir ve Hızlı </span>
                         <br/> 
                         <span className="text-gradient bg-gradient-to-r from-primary to-primary/70">Kripto Para Al/Sat!</span>
                       </h3>
                       
                       <p className="text-secondaryTwo mt-6 mb-8 text-lg">
                         Hızlı ve güvenilir bir şekilde Kripto Para almak ve satmak <span className="text-primary font-semibold">çok kolay!</span> <br/> 
                         Hemen üye olun ve kripto dünyasına adım atın.
                       </p>
                       
                       <div className="flex flex-wrap gap-4">
                           <Button 
                              onClick={() => window.location.href = `https://exchange.gmskripto.com`}
                              className="py-3 px-8 text-base bg-gradient-to-r from-primary to-primary/80 hover:from-primary/90 hover:to-primary shadow-lg shadow-primary/20 border-none"
                           >
                              Hemen Başla
                           </Button>
                           
                           <button 
                              onClick={() => window.location.href = `https://exchange.gmskripto.com/signin`}
                              className="py-3 px-8 text-base bg-transparent border border-white/20 hover:border-white/40 text-white rounded-full transition-all"
                           >
                              Giriş Yap
                           </button>
                       </div>
                       
                       <div className="mt-10 grid grid-cols-3 gap-6">
                           <div className="text-center">
                               <p className="text-primary font-bold text-2xl">Gelişmiş</p>
                               <p className="text-secondaryTwo text-sm">Destek</p>
                           </div>
                           <div className="text-center">
                               <p className="text-primary font-bold text-2xl">100+</p>
                               <p className="text-secondaryTwo text-sm">Kripto Para</p>
                           </div>
                           <div className="text-center">
                               <p className="text-primary font-bold text-2xl">Düşük</p>
                               <p className="text-secondaryTwo text-sm">Komisyon</p>
                           </div>
                       </div>
                   </div>
                   
                   <div className="md:col-start-8 md:col-end-13 col-start-1 col-end-13 hidden md:block mt-20 md:mt-0 relative">
                       {/* Görsel etrafında parlama efekti */}
                       <div className="absolute -inset-4 bg-primary/10 rounded-full blur-xl"></div>
                       
                       <div className="relative z-10 transform hover:scale-105 transition-transform duration-700">
                            <img className="max-w-[570px] w-full" src={HeroImg} alt="Hero Img"/>
                       </div>
                       
                       {/* Dekoratif elementler */}
                       <div className="absolute top-1/4 -left-10 w-20 h-20 bg-primary/30 rounded-full blur-xl"></div>
                       <div className="absolute bottom-1/3 right-0 w-16 h-16 bg-primary/20 rounded-full blur-lg"></div>
                   </div>
               </div>
           </Wrapper>
       </div>
    )
}

export {Hero}
